export const IMAGE_TIME_OUT = 30000;
export const VIDEO_TIME_OUT = 30000;
